import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalSettings } from '../hooks/useGlobalSettings';
import toast from 'react-hot-toast';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const { settings } = useGlobalSettings();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error('Informe seu e-mail');
      return;
    }
    setIsSubmitting(true);
    setSent(false);
    try {
      const response = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setSent(true);
        toast.success(data.message);
      } else {
        toast.error(data.message || 'Não foi possível enviar o e-mail.');
      }
    } catch {
      toast.error('Erro de conexão. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl overflow-hidden">
        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-1/2 p-12 flex items-center justify-center text-white" style={{ background: '#008070' }}>
            <div className="text-center">
              <div className="w-32 h-32 bg-white rounded-2xl mx-auto mb-8 flex items-center justify-center shadow-lg">
                {settings?.iconUrl ? (
                  <img src={settings.iconUrl} alt="Ícone" className="w-24 h-24 object-contain" />
                ) : (
                  <img src="/favicon.png" alt="AutoWhats" className="w-24 h-24 object-contain" />
                )}
              </div>
              <h1 className="text-4xl font-bold mb-4">AutoWhats 3.0</h1>
              <p className="text-xl text-gray-100 mb-8">Sistema de Gestão de Campanhas</p>
              <p className="text-gray-200 max-w-md">
                Recupere o acesso à sua conta informando o e-mail de cadastro.
              </p>
            </div>
          </div>

          <div className="lg:w-1/2 p-12">
            <div className="max-w-md mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Recuperar senha</h2>
                <p className="text-gray-600">
                  Informe o e-mail da sua conta. Enviaremos um link para redefinir a senha.
                </p>
              </div>

              {sent ? (
                <div className="space-y-4">
                  <div className="p-4 rounded-xl bg-green-50 border border-green-200 text-green-800 text-sm">
                    Se o e-mail estiver cadastrado, você receberá um link para redefinir a senha. Verifique sua caixa de entrada e spam.
                  </div>
                  <Link
                    to="/login"
                    className="block w-full text-center py-3 px-6 rounded-xl font-medium text-white"
                    style={{ background: '#008070' }}
                  >
                    Voltar ao login
                  </Link>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      E-mail
                    </label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:border-transparent transition-colors"
                      style={{ '--tw-ring-color': '#008070' } as React.CSSProperties}
                      placeholder="seu@email.com"
                      disabled={isSubmitting}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full text-white py-3 px-6 rounded-xl font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    style={{ background: '#008070', '--tw-ring-color': '#008070' } as React.CSSProperties}
                  >
                    {isSubmitting ? 'Enviando...' : 'Enviar link para redefinir senha'}
                  </button>

                  <p className="text-center">
                    <Link to="/login" className="text-sm font-medium hover:underline" style={{ color: '#008070' }}>
                      Voltar ao login
                    </Link>
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
